import { CategoriesController } from './CategoriesController';
import { CategoriesService } from '~/shared/api/ke-gateway/categories';
import { computed } from 'vue';
import { usePopups } from '@mm-frontend/mm-web-ui-kit';
import { scrollToTop } from '~/shared/helpers/globalScroll';
import { watchThrottled } from '@vueuse/core';
import { useAppSearchBounding } from '~/features/app-search';
import DesktopCatalogPopup from '../ui/DesktopCatalogPopup.vue';

const categoriesService = new CategoriesService();
const controller = new CategoriesController(categoriesService);

const { createPopup } = usePopups();
const desktopCatalogPopup = createPopup({
  component: DesktopCatalogPopup,
});
desktopCatalogPopup.onShow(() => {
  scrollToTop();
});

controller.setCatalogPopup(desktopCatalogPopup);

export function useCategories() {
  const { searchOffsetFromTop } = useAppSearchBounding();

  watchThrottled(
    () => [searchOffsetFromTop.value],
    ([top]) => {
      desktopCatalogPopup.updateOptions({
        withoutOverlay: true,
        spacingTop: top,
      });
    },
    { throttle: 100 }
  );

  const isLoading = computed(() => controller.isLoading.value);
  const isCategoriesLoaded = computed(() => controller.isCategoriesLoaded.value);
  const rootCategories = computed(() => controller.rootCategories.value);
  const promoCategories = computed(() => controller.promoCategories.value);

  async function fetchCategories(): Promise<void> {
    if (isCategoriesLoaded.value) return;
    await controller.fetchCategories();
  }

  function openCatalogModal() {
    controller.openCatalogModal();
  }

  function closeCatalogModal() {
    controller.closeCatalogModal();
  }

  const isCatalogModalOpened = computed(() => {
    return controller.isCatalogModalOpened;
  });

  return {
    rootCategories,
    promoCategories,
    fetchCategories,
    isLoading,
    isCategoriesLoaded,
    isCatalogModalOpened,
    openCatalogModal,
    closeCatalogModal,
    _getTrackerPayload: () => controller._getTrackerPayload(),
  };
}
